// React
import {useState} from "react";

// Компоненты
import {Modal} from "../../../general_components/Modal";

// Хуки
import {
    useCreateProject,
    useCreateUser,
    useDeleteProject,
    useDeleteUser,
    useGetUsers,
    useUpdateProject,
    useUpdateUser
} from "../../../hooks/queries";

// Константы
import {PASSWORD} from "../../../consts";

export function Section({category, first_line = true}) {
    const createUser = useCreateUser()
    const [createUserModal, setCreateUserModal] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [user, setUser] = useState({
        name: "",
        photo: "",
        category
    })

    function changeParamUser(param, value) {
        setUser({...user, [param]: value})
    }

    function createUserFunction(e) {
        e.preventDefault()
        createUser.mutate(user)
        setCreateUserModal(false)
    }

    return (
        <section>
            {first_line
                && <div className="line"/>
            }

            <div>
                <button className="category font2" onClick={() => setIsOpen(!isOpen)}>
                    {category}
                </button>
                {!!localStorage.getItem(PASSWORD) &&
                    <button
                        className="add"
                        onClick={() => setCreateUserModal(true)}
                    >
                        +
                    </button>
                }
            </div>

            <div className={`grid ${isOpen ? "open" : ""}`}>
                <div className={`content ${isOpen ? "open" : ""}`}>
                    <div className="line"/>
                    <Content category={category}/>
                </div>
            </div>

            {/* Модальное окно */}
            <Modal modal={createUserModal} setModal={setCreateUserModal}>
                <h1>Создание нового сотрудника</h1>
                <form onSubmit={createUserFunction}>
                    <input
                        type="text"
                        placeholder="Ник"
                        value={user.name}
                        onChange={e =>
                            changeParamUser("name", e.target.value)
                        }
                        autoComplete="name"
                    />
                    <input
                        type="text"
                        placeholder="Ссылка на аватарку"
                        value={user.photo}
                        onChange={e =>
                            changeParamUser("photo", e.target.value)
                        }
                        autoComplete="avatar_url"
                    />
                    <button type="submit">Создать</button>
                </form>
            </Modal>
        </section>
    )
}

export function Content({category}) {
    const {
        data,
        isError,
        isLoading,
        error
    } = useGetUsers()

    if (isLoading) {
        return <p className="center_text">Загрузка...</p>
    } else if (isError || !data?.users) {
        return <p className="center_text">Ошибка - {error?.message}</p>
    }

    return (
        data.users.filter(user => user.categories.includes(category)).map(user =>
            <Box key={user._id} name={user.name} photo={user.photo} category={category}>
                {
                    user.projects?.map(project =>
                        <ImgBox photo={project?.photo} text={project?.text} name={user.name}/>
                    )
                }
            </Box>
        )
    )
}

export function Box(
    {
        children, name, photo, category
    }) {
    const createProject = useCreateProject()
    const updateUser = useUpdateUser()
    const deleteUser = useDeleteUser()

    const [isOpen, setIsOpen] = useState(false)

    // Пользователи
    const [user, setUser] = useState({
        name,
        newName: name,
        photo
    })
    const [editUserModal, setEditUserModal] = useState(false)
    const [deleteUserModal, setDeleteUserModal] = useState(false)

    // Проекты
    const [project, setProject] = useState({
        text: "",
        photo: "",
        category,
        name
    })
    const [createProjectModal, setCreateProjectModal] = useState(false)

    function changeParamUser(param, value) {
        setUser({...user, [param]: value})
    }

    function changeParamProject(param, value) {
        setProject({...project, [param]: value})
    }

    function createProjectFunction(e) {
        e.preventDefault()
        createProject.mutate(project)
        setCreateProjectModal(false)
    }

    function updateUserFunction(e) {
        e.preventDefault()
        updateUser.mutate(user)
        setEditUserModal(false)
    }

    function deleteUserFunction(e) {
        e.preventDefault()
        deleteUser.mutate({
            name,
            category
        })
        setDeleteUserModal(false)
    }

    return (
        <article className="box">
            <div className="box_main">
                <AvatarBox photo={photo} avatar/>
                <div className="text">
                    <div className="name">
                        <h2>{name}</h2>
                        {!!localStorage.getItem(PASSWORD) &&
                            <>
                                <button onClick={() => setEditUserModal(true)}>
                                    <i className="bi bi-pencil-square edit"/>
                                </button>
                                <button onClick={() => setDeleteUserModal(true)}>
                                    <i className="bi bi-trash"/>
                                </button>
                            </>
                        }
                    </div>
                    <div className="button">
                        <button onClick={() => setIsOpen(!isOpen)}>
                            Портфолио
                        </button>
                        {!!localStorage.getItem(PASSWORD) &&
                            <button
                                className="add"
                                onClick={() => setCreateProjectModal(true)}
                            >
                                +
                            </button>
                        }
                    </div>
                </div>
            </div>
            <div className={`grid ${isOpen ? "open" : ""}`}>
                <div className={`content ${isOpen ? "open" : ""}`}>
                    <div className="img_section">
                        {children}
                    </div>
                </div>
            </div>


            {/* Модальное окно для создания проекта */}
            <Modal modal={createProjectModal} setModal={setCreateProjectModal}>
                <h1>Создание нового проекта</h1>
                <form onSubmit={createProjectFunction}>
                    <input
                        type="text"
                        placeholder="Ссылка на проект"
                        value={project.photo}
                        onChange={e =>
                            changeParamProject("photo", e.target.value)
                        }
                        autoComplete="photo_url"
                    />
                    <input
                        type="text"
                        placeholder="Текст (не обяз)"
                        value={project.text}
                        onChange={e =>
                            changeParamProject("text", e.target.value)
                        }
                        autoComplete="text"
                    />
                    <button type="submit">Создать</button>
                </form>
            </Modal>


            {/* Модальное окно для изменения сотрудника */}
            <Modal modal={editUserModal} setModal={setEditUserModal}>
                <h1>
                    Изменение сотрудника<br/>
                    {name}
                </h1>
                <form onSubmit={updateUserFunction}>
                    <input
                        type="text"
                        placeholder="Новый ник"
                        value={user.newName}
                        onChange={e =>
                            changeParamUser("newName", e.target.value)
                        }
                        autoComplete="name"
                    />
                    <input
                        type="text"
                        placeholder="Новая ссылка на аватарку"
                        value={user.photo}
                        onChange={e =>
                            changeParamUser("photo", e.target.value)
                        }
                        autoComplete="avatar_url"
                    />
                    <button type="submit">Изменить</button>
                </form>
            </Modal>


            {/* Модальное окно для удаления сотрудника */}
            <Modal modal={deleteUserModal} setModal={setDeleteUserModal}>
                <h1>
                    Удаление сотрудника<br/>
                    {name}
                </h1>

                <form onSubmit={deleteUserFunction}>
                    <p>Вы точно хотите удалить?</p>

                    <button
                        type="submit"
                        className="red"
                    >
                        Да, удалить!
                    </button>
                </form>
            </Modal>
        </article>
    )
}

export function AvatarBox({photo}) {
    return (
        <figure
            className="img_box avatar"
        >
            <img
                src={photo}
                alt="Аватарка"
                className="img"
            />
        </figure>
    )
}

export function ImgBox({photo, name, text = ""}) {
    // Проекты
    const updateProject = useUpdateProject()
    const deleteProject = useDeleteProject()

    const [isOpen, setIsOpen] = useState(false)
    const [editProjectModal, setEditProjectModal] = useState(false)
    const [deleteProjectModal, setDeleteProjectModal] = useState(false)

    const [project, setProject] = useState({
        text,
        photo,
        newPhoto: photo,
        name
    })

    function changeParamProject(param, value) {
        setProject({...project, [param]: value})
    }

    function resizeImg() {
        setIsOpen(!isOpen)
}

    function updateUserFunction(e) {
        e.preventDefault()
        updateProject.mutate(project)
        setEditProjectModal(false)
    }

    function deleteUserFunction(e) {
        e.preventDefault()
        deleteProject.mutate({
            name,
            photo
        })
        setDeleteProjectModal(false)
    }

    return (
        <>
            <figure
                className="img_box"
                id={isOpen ? "fullscreen" : ""}
                style={{zIndex: isOpen ? 3 : 0}}
                onClick={resizeImg}
            >
                <img
                    src={photo}
                    alt="Проект"
                    className="img"
                />
                {!!localStorage.getItem(PASSWORD) &&
                    <div className="buttons_img" onClick={e => e.stopPropagation()}>
                        <button onClick={() => setEditProjectModal(true)}>
                            <i className="bi bi-pencil-square edit"/>
                        </button>
                        <button onClick={() => setDeleteProjectModal(true)}>
                            <i className="bi bi-trash"/>
                        </button>
                    </div>
                }
                {!!text &&
                    <p className="text">
                        {text}
                    </p>
                }
            </figure>

            {/* Модальное окно для изменения проекта */}
            <Modal modal={editProjectModal} setModal={setEditProjectModal}>
                <h1>
                    Изменение проекта
                </h1>
                <form onSubmit={updateUserFunction}>
                    <input
                        type="text"
                        placeholder="Новая ссылка на проект"
                        value={project.newPhoto}
                        onChange={e =>
                            changeParamProject("newPhoto", e.target.value)
                        }
                        autoComplete="project_url"
                    />
                    <input
                        type="text"
                        placeholder="Новый текст"
                        value={project.text}
                        onChange={e =>
                            changeParamProject("text", e.target.value)
                        }
                        autoComplete="text"
                    />
                    <button type="submit">Изменить</button>
                </form>
            </Modal>


            {/* Модальное окно для удаления проекта */}
            <Modal modal={deleteProjectModal} setModal={setDeleteProjectModal}>
                <h1>
                    Удаление проекта
                </h1>

                <form onSubmit={deleteUserFunction}>
                    <p>Вы точно хотите удалить?</p>

                    <button
                        type="submit"
                        className="red"
                    >
                        Да, удалить!
                    </button>
                </form>
            </Modal>
        </>
    )
}
